import { render, staticRenderFns } from "./InsuranceCompanyAdd.vue?vue&type=template&id=5f96c4a8&"
import script from "./InsuranceCompanyAdd.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports